import DiamondEarRings1 from "../../Assets/DiamondEarRings1.jpg";
import DiamondEarRings2 from "../../Assets/DiamondEarRings2.jpg";
import DiamondEarRings3 from "../../Assets/DiamondEarRings3.jpg";
import DiamondEarRings4 from "../../Assets/DiamondEarRings4.jpg";
import GoldEarRings1 from "../../Assets/GoldEarRings1.jpg";
import GoldEarRings2 from "../../Assets/GoldEarRings2.jpg";
import GoldEarRings3 from "../../Assets/GoldEarRings3.jpg";
import GoldEarRings4 from "../../Assets/GoldEarRings4.jpg";
import DiamondRings1 from "../../Assets/DiamondRing1.jpg";
import DiamondRings2 from "../../Assets/DiamondRing2.jpg";
import DiamondEarringsvideo1 from "../../Assets/DiamondEarringvideo1.mp4";
import DiamondWatch1 from "../../Assets/DiamondWatchGroup1.jpg";
import DiamondWatch2 from "../../Assets/DiamondWatchGroup2.jpg";
import DiamondWatch3 from "../../Assets/DiamondWatchGroup3.jpg";
import DiamondWatch4 from "../../Assets/DiamondWatchGroup4.jpg";
import DiamondWatch from "../../Assets/DiamondWatchSlider02.avif";

import DiamondWatchSlider2 from "../../Assets/DiamondImageSlider2.jpg";
import video1 from "../../Assets/DiamondWatchVideo1.mp4";
import video2 from "../../Assets/DiamondWatchVideo2.mp4";
import Moissaniteimg1 from "../../Assets/Moissanite_Clover Bracelet_1.jpg";
import Moissaniteimg2 from "../../Assets/Moissanite_Clover Bracelet_2.jpg";
import Moissaniteimg3 from "../../Assets/Moissanite_Clover Bracelet_3.jpg";
import Moissaniteimg4 from "../../Assets/Moissanite_Clover Bracelet_4.jpg";
import Moissaniteimg11 from "../../Assets/Moissanite_Clover Bracelet_11.jpg";
import Moissaniteimg12 from "../../Assets/Moissanite_Clover Bracelet_12.jpg";
import Moissaniteimg13 from "../../Assets/Moissanite_Clover Bracelet_13.jpg";
import Moissaniteimg14 from "../../Assets/Moissanite_Clover Bracelet_14.jpg";
import Moissaniteimg31 from "../../Assets/Moissanite Clover Bracelet_31.jpg";
import Moissaniteimg32 from "../../Assets/Moissanite Clover Bracelet_32.jpg";
import Moissaniteimg33 from "../../Assets/Moissanite Clover Bracelet_33.jpg";
import Moissaniteimg34 from "../../Assets/Moissanite Clover Bracelet_34.jpg";
import MoissaniteVideo1 from "../../Assets/Moissanite Clover Bracelet video1.mp4";
import MoissaniteVideo3 from "../../Assets/Moissanite Clover Bracelet video3.mp4";

import mensGoldRing1 from "../../Assets/925 Cz Coin Mens Ring 1.jpg";
import LadiesRing11 from "../../Assets/Ladies Moissanite Ring 11.jpg";
import LadiesRing12 from "../../Assets/Ladies Moissanite Ring 12.jpg";
import LadiesRing13 from "../../Assets/Ladies Moissanite Ring 13.jpg";
import LadiesRing14 from "../../Assets/Ladies Moissanite Ring 14.jpg";
import LadiesRing21 from "../../Assets/Ladies Moissanite Ring 21.jpg";
import LadiesRing22 from "../../Assets/Ladies Moissanite Ring 22.jpg";
import MenRing1 from "../../Assets/Men's Moissanite Ring 1.jpg";
import MenRing2 from "../../Assets/Men's Moissanite Ring 2.jpg";
import MenRing3 from "../../Assets/Men's Moissanite Ring 3.jpg";
import MenRing4 from "../../Assets/Men's Moissanite Ring 4.jpg";
import MenRing11 from "../../Assets/Mens Moissanite Ring 11.jpg";
import MenRing12 from "../../Assets/Mens Moissanite Ring 12.jpg";
import MenRing13 from "../../Assets/Mens Moissanite Ring 13.jpg";
import MenRing14 from "../../Assets/Mens Moissanite Ring 14.jpg";
import ladiesRingvideo1 from "../../Assets/Ladies Moissanite Ring video1.mp4";
import ladiesRingvideo2 from "../../Assets/Ladies Moissanite Ring video2.mp4";
import ladiesRingvideo3 from "../../Assets/Mens Moissanite Ring video3.mp4";
import heartPendent1 from "../../Assets/10ky Initial Cz Heart Pendant 1.jpg";
import heartPendent2 from "../../Assets/10ky Initial Cz Heart Pendant 2.jpg";
import heartPendent3 from "../../Assets/10ky Initial Cz Heart Pendant 3.jpg";
import heartPendent4 from "../../Assets/10ky Initial Cz Heart Pendant 4.jpg";
import NumberPendent1 from "../../Assets/925 Moissanite Number Pendant 1.jpg";
import NumberPendent2 from "../../Assets/925 Moissanite Number Pendant 2.jpg";
import NumberPendent3 from "../../Assets/925 Moissanite Number Pendant 3.jpg";
import NumberPendent4 from "../../Assets/925 Moissanite Number Pendant 4.jpg";
import GlobePendent1 from "../../Assets/Globe crown Moissanite Pendant_1.jpg";
import GlobePendent2 from "../../Assets/Globe crown Moissanite Pendant_2.jpg";
import GlobePendent3 from "../../Assets/Globe crown Moissanite Pendant_3.jpg";
import GlobePendent4 from "../../Assets/Globe crown Moissanite Pendant_4.jpg";
import Moissanite_A from "../../Assets/Ss Moissanite Initial Pendant A.jpg";
import Moissanite_B from "../../Assets/Ss Moissanite Initial Pendant B.jpg";
import Moissanite_C from "../../Assets/Ss Moissanite Initial Pendant C.jpg";
import Moissanite_D from "../../Assets/Ss Moissanite Initial Pendant D.jpg";
import pandentVideoA from "../../Assets/925 Cz Initial A Pendant video.mp4";
import pandentVideoB from "../../Assets/925 Cz Initial B Pendant video.mp4";
import pandentVideoHeart from "../../Assets/10ky Initial Cz Heart Pendant video.mp4";

export const categoryData = [
  {
    id: "1",
    name: "Rings",
    category: "Moissanite Diamond Rings",
    media: {
      carousel: [
        {
          type: "image",
          src: mensGoldRing1,
          alt: "Rings Carousel 1",
        },
        {
          type: "image",
          src: LadiesRing11,
          alt: "Earrings Carousel 2",
        },
        {
          type: "image",
          src: LadiesRing21,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: MenRing11,
          alt: "Earrings Carousel 2",
        },
      ],
      imagesComponent: [
        {
          type: "image",
          src: LadiesRing11,
          alt: "Moissanite Ladies Ring 1",
          name: "Moissanite Ladies Ring 1",
        },
        {
          type: "image",
          src: LadiesRing12,
          alt: "Moissanite Ladies Ring 2",
          name: "Moissanite Ladies Ring 2",
        },
        {
          type: "image",
          src: LadiesRing13,
          alt: "Moissanite Ladies Ring 3",
          name: "Moissanite Ladies Ring 3",
        },
        {
          type: "image",
          src: LadiesRing14,
          alt: "Moissanite Ladies Ring 4",
          name: "Moissanite Ladies Ring 4",
        },
      ],
      videoComponent: [{ type: "video", src: ladiesRingvideo1 }],
      content: {
        title: (
          <>
            Timeless Sparkle,
            <br className="hidden md:block" /> Diamond Rings
          </>
        ),
        description: (
          <>
            Discover our stunning
            <br className="hidden md:block" />
            collection of diamond rings. Designed to
            <br className="hidden md:block" />
            capture love, elegance, and sophistication —
            <br className="hidden md:block" />
            perfect for engagements, weddings, or
            <br className="hidden md:block" />
            adding a touch of luxury to your everyday style.
          </>
        ),
        buttonText: "EXPLORE DIAMOND RINGS",
        onButtonClick: () => alert("Explore Rings clicked!"),
      },

      middleImageComponent: [
        {
          type: "image",
          src: LadiesRing22,
          alt: "Earrings Middle 1",
        },
        {
          type: "video",
          src: ladiesRingvideo2,
        },
        {
          type: "image",
          src: LadiesRing11,
          alt: "Earrings Middle 2",
        },

        {
          type: "image",
          src: LadiesRing21,
          alt: "Earrings Middle 1",
        },
        {
          type: "image",
          src: LadiesRing14,
          alt: "Earrings Middle 2",
        },
        {
          type: "video",
          src: ladiesRingvideo3,
          alt: "Earrings Middle 1",
        },
      ],
      smallImgCarousel: [
        {
          src: MenRing1,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE RING",
          title: "Classic Men's Silver Moissanite Ring",
        },
        {
          src: MenRing2,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE RING",
          title: "Classic Men's Silver Moissanite Ring",
        },
        {
          src: MenRing3,
          alt: "Moissanite Ring 3",
          content: "PREMIUM | MOISSANITE RING",
          title: "Classic Men's Silver Moissanite Ring",
        },
        {
          src: MenRing4,
          alt: "Moissanite Ring 4",
          content: "LIMITED EDITION | MOISSANITE RING",
          title: "Classic Men's Silver Moissanite Ring",
        },
        {
          src: LadiesRing11,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE RING",
          title: "Classic Ladies Silver Moissanite Ring",
        },
        {
          src: LadiesRing12,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE RING",
          title: "Classic Ladies Silver Moissanite Ring",
        },
        {
          src: LadiesRing13,
          alt: "Moissanite Ring 3",
          content: "PREMIUM | MOISSANITE RING",
          title: "Classic Ladies Silver Moissanite Ring",
        },
        {
          src: LadiesRing14,
          alt: "Moissanite Ring 4",
          content: "LIMITED EDITION | MOISSANITE RING",
          title: "Classic Ladies Silver Moissanite Ring",
        },
        {
          src: LadiesRing21,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE RING",
          title: "Ladies Moissanite Ring",
        },
        {
          src: LadiesRing22,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE RING",
          title: "Ladies Moissanite Ring",
        },
        {
          src: LadiesRing21,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE RING",
          title: "Ladies Moissanite Ring",
        },
        {
          src: LadiesRing22,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE RING",
          title: "Ladies Moissanite Ring",
        },
      ],

      recentImg: [
        {
          src: LadiesRing11,
          alt: "Diamond Ring 1",
          content: "ELEGANT DESIGN | BEST SELLER",
          title: "Moissanite Ladies Ring 1",
        },
        {
          src: LadiesRing12,
          alt: "Diamond Ring 2",
          content: "NEW ARRIVAL | SIGNATURE STYLE",
          title: "Moissanite Ladies Ring 2",
        },
      ],

      discoverImg: [
        {
          src: MenRing11,
          type: "image",
        },
        {
          src: MenRing12,
          type: "image",
        },
        {
          src: MenRing13,
          type: "image",
        },
        {
          src: MenRing14,
          type: "image",
        },
      ],
    },
  },
  {
    id: "2",
    name: "Earrings",
    category: "Moissanite Studs Earrings",
    media: {
      carousel: [
        {
          type: "image",
          src: DiamondEarRings1,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: GoldEarRings4,
          alt: "Earrings Carousel 2",
        },
        {
          type: "image",
          src: DiamondEarRings3,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: DiamondRings1,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: GoldEarRings4,
          alt: "Earrings Carousel 2",
        },
        {
          type: "image",
          src: DiamondRings2,
          alt: "Earrings Carousel 2",
        },
      ],
      imagesComponent: [
        {
          type: "image",
          src: DiamondEarRings1,
          alt: "Earrings Gallery 1",
          name: "Moissanite Fancy Studs 1",
        },
        {
          type: "image",
          src: DiamondEarRings3,
          alt: "Earrings Gallery 2",
          name: "Moissanite Fancy Studs 2",
        },
        {
          type: "image",
          src: DiamondEarRings2,
          alt: "Earrings Gallery 3",
          name: "Moissanite Fancy Studs 3",
        },
        {
          type: "image",
          src: DiamondEarRings4,
          alt: "Earrings Gallery 4",
          name: "Moissanite Fancy Studs 4",
        },
      ],
      videoComponent: [
        {
          type: "video",
          src: DiamondEarringsvideo1,
        },
      ],
      content: {
        title: (
          <>
            Elegant & Shiny,
            <br className="hidden md:block" /> Exclusive Earrings
          </>
        ),
        description: (
          <>
            Discover our exquisite collection of earrings,
            <br className="hidden md:block" />
            crafted with passion and precision.
            <br className="hidden md:block" />
            Each piece embodies timeless elegance,
            <br className="hidden md:block" />
            perfect for every occasion and style.
          </>
        ),
        buttonText: "SHOP RINGS",
        onButtonClick: () => alert("Explore Rings clicked!"),
      },
      middleImageComponent: [
        {
          type: "image",
          src: DiamondEarRings1,
          alt: "Earrings Middle 1",
        },
        {
          type: "image",
          src: DiamondEarRings4,
          alt: "Earrings Middle 2",
        },
        {
          type: "image",
          src: DiamondEarRings2,
          alt: "Earrings Middle 3",
        },
        {
          type: "image",
          src: DiamondEarRings3,
          alt: "Earrings Middle 4",
        },
        {
          type: "image",
          src: DiamondEarRings4,
          alt: "Earrings Middle 5",
        },
        {
          type: "image",
          src: DiamondEarRings1,
          alt: "Earrings Middle 6",
        },
      ],
      smallImgCarousel: [
        {
          src: GoldEarRings1,
          alt: "Small Earrings 1",
          title: "Gold Classic Earrings",
          content: "925 Moissanite Fancy Studs 1",
        },
        {
          src: GoldEarRings2,
          alt: "Small Earrings 2",
          title: "Gold Classic Earrings",
          content: "925 Moissanite Fancy Studs 1",
        },
        {
          src: GoldEarRings3,
          alt: "Small Earrings 3",
          title: "Gold Classic Earrings",
          content: "925 Moissanite Fancy Studs 1",
        },
        {
          src: GoldEarRings4,
          alt: "Small Earrings 4",
          title: "Gold Classic Earrings",
          content: "925 Moissanite Fancy Studs 1",
        },
        {
          src: DiamondEarRings1,
          alt: "Diamond Earrings 1",
          title: "Diamond Earrings",
          content: "925 Moissanite Fancy Studs 2",
        },
        {
          src: DiamondEarRings2,
          alt: "Diamond Earrings 2",
          title: "Diamond Earrings",
          content: "925 Moissanite Fancy Studs 2",
        },
        {
          src: DiamondEarRings3,
          alt: "Diamond Earrings 3",
          title: "Diamond Earrings",
          content: "925 Moissanite Fancy Studs 2",
        },
        {
          src: DiamondEarRings4,
          alt: "Diamond Earrings 4",
          title: "Diamond Earrings",
          content: "925 Moissanite Fancy Studs 2",
        },
      ],
      recentImg: [
        {
          src: GoldEarRings1,
          alt: "Recent Earrings 1",
          content: "ELEGANT DESIGN | BEST SELLER",
          title: "925 Moissanite Fancy Studs 1",
        },
        {
          src: GoldEarRings2,
          alt: "Recent Earrings 2",
          content: "NEW ARRIVAL | SIGNATURE STYLE",
          title: "925 Moissanite Fancy Studs 1",
        },
      ],
      discoverImg: [
        {
          src: GoldEarRings1,
          type: "image",
        },
        {
          src: GoldEarRings3,
          type: "image",
        },
        {
          src: GoldEarRings2,
          type: "image",
        },
        {
          src: GoldEarRings4,
          type: "image",
        },
      ],
    },
  },
  {
    id: "3",
    name: "Bracelets",
    category: "Moissanite Clover Bracelet",
    media: {
      carousel: [
        {
          type: "image",
          src: Moissaniteimg1,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: Moissaniteimg2,
          alt: "Earrings Carousel 2",
        },
        {
          type: "image",
          src: Moissaniteimg3,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: Moissaniteimg4,
          alt: "Earrings Carousel 2",
        },
      ],
      imagesComponent: [
        {
          type: "image",
          src: Moissaniteimg34,
          alt: "Moissanite Bracelet 1",
          name: "Moissanite Bracelet 1",
        },
        {
          type: "image",
          src: Moissaniteimg32,
          alt: "Moissanite Bracelet 2",
          name: "Moissanite Bracelet 2",
        },
        {
          type: "image",
          src: Moissaniteimg33,
          alt: "Moissanite Bracelet 3",
          name: "Moissanite Bracelet 3",
        },
        {
          type: "image",
          src: Moissaniteimg31,
          alt: "Moissanite Bracelet 4",
          name: "Moissanite Bracelet 4",
        },
      ],
      videoComponent: [{ type: "video", src: MoissaniteVideo1 }],
      content: {
        title: (
          <>
            Graceful Charm,
            <br className="hidden md:block" /> Diamond Bracelets
          </>
        ),
        description: (
          <>
            Elevate your style with our exquisite
            <br className="hidden md:block" />
            collection of diamond bracelets. Each design
            <br className="hidden md:block" />
            blends timeless beauty with modern elegance —
            <br className="hidden md:block" />
            perfect for everyday wear or special occasions.
          </>
        ),
        buttonText: "EXPLORE DIAMOND BRACELETS",
        onButtonClick: () => alert("Explore Bracelets clicked!"),
      },

      middleImageComponent: [
        {
          type: "image",
          src: Moissaniteimg1,
          alt: "Earrings Middle 1",
        },
        {
          type: "video",
          src: MoissaniteVideo1,
        },
        {
          type: "image",
          src: Moissaniteimg11,
          alt: "Earrings Middle 2",
        },

        {
          type: "image",
          src: Moissaniteimg33,
          alt: "Earrings Middle 1",
        },
        {
          type: "image",
          src: Moissaniteimg4,
          alt: "Earrings Middle 2",
        },
        {
          type: "video",
          src: MoissaniteVideo3,
          alt: "Earrings Middle 1",
        },
      ],
      smallImgCarousel: [
        {
          src: Moissaniteimg1,
          alt: "Moissanite Bracelet 1",
          content: "BEST SELLER | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 1",
        },
        {
          src: Moissaniteimg2,
          alt: "Moissanite Bracelet 2",
          content: "NEW ARRIVAL | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 1",
        },
        {
          src: Moissaniteimg3,
          alt: "Moissanite Bracelet 3",
          content: "PREMIUM | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 1",
        },
        {
          src: Moissaniteimg4,
          alt: "Moissanite Bracelet 4",
          content: "LIMITED EDITION | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 1",
        },
        {
          src: Moissaniteimg11,
          alt: "Moissanite Bracelet 1",
          content: "BEST SELLER | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 2",
        },
        {
          src: Moissaniteimg12,
          alt: "Moissanite Bracelet 2",
          content: "NEW ARRIVAL | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 2",
        },
        {
          src: Moissaniteimg13,
          alt: "Moissanite Bracelet 3",
          content: "PREMIUM | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 2",
        },
        {
          src: Moissaniteimg14,
          alt: "Moissanite Bracelet 4",
          content: "LIMITED EDITION | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 2",
        },
        {
          src: Moissaniteimg31,
          alt: "Moissanite Bracelet 1",
          content: "BEST SELLER | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 3",
        },
        {
          src: Moissaniteimg32,
          alt: "Moissanite Bracelet 2",
          content: "NEW ARRIVAL | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 3",
        },
        {
          src: Moissaniteimg33,
          alt: "Moissanite Bracelet 3",
          content: "PREMIUM | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 3",
        },
        {
          src: Moissaniteimg34,
          alt: "Moissanite Bracelet 4",
          content: "LIMITED EDITION | MOISSANITE BRACELET",
          title: "Moissanite Clover Bracelet 3",
        },
      ],
      recentImg: [
        {
          src: Moissaniteimg1,
          alt: "Diamond Bracelet 1",
          content: "ELEGANT DESIGN | BEST SELLER",
          title: "Moissanite Clover Bracelet 1",
        },
        {
          src: Moissaniteimg32,
          alt: "Diamond Bracelet 2",
          content: "NEW ARRIVAL | SIGNATURE STYLE",
          title: "Moissanite Clover Bracelet 2",
        },
      ],
      discoverImg: [
        {
          src: Moissaniteimg31,
          type: "image",
        },
        {
          src: Moissaniteimg32,
          type: "image",
        },
        {
          src: Moissaniteimg33,
          type: "image",
        },
        {
          src: Moissaniteimg34,
          type: "image",
        },
      ],
    },
  },
  {
    id: "4",
    name: "Pendants",
    category: "Moissanite Diamond Pendants",
    media: {
      carousel: [
        {
          type: "image",
          src: heartPendent1,
          alt: "Rings Carousel 1",
        },
        {
          type: "image",
          src: NumberPendent1,
          alt: "Earrings Carousel 2",
        },
        {
          type: "image",
          src: NumberPendent2,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: Moissanite_A,
          alt: "Earrings Carousel 2",
        },
      ],
      imagesComponent: [
        {
          type: "image",
          src: heartPendent1,
          alt: "10ky Initial Cz Heart Pendant 1",
          name: "10ky Initial Cz Heart Pendant 1",
        },
        {
          type: "image",
          src: heartPendent2,
          alt: "10ky Initial Cz Heart Pendant 2",
          name: "10ky Initial Cz Heart Pendant 2",
        },
        {
          type: "image",
          src: heartPendent3,
          alt: "10ky Initial Cz Heart Pendant 3",
          name: "10ky Initial Cz Heart Pendant 3",
        },
        {
          type: "image",
          src: heartPendent4,
          alt: "10ky Initial Cz Heart Pendant 4",
          name: "10ky Initial Cz Heart Pendant 4",
        },
      ],
      videoComponent: [{ type: "video", src: pandentVideoHeart }],
      content: {
        title: (
          <>
            Graceful Glow,
            <br className="hidden md:block" /> Diamond Pendants
          </>
        ),
        description: (
          <>
            Adorn yourself with our elegant
            <br className="hidden md:block" />
            collection of diamond pendants. Each piece
            <br className="hidden md:block" />
            reflects timeless charm and modern artistry —
            <br className="hidden md:block" />
            perfect for daily elegance or memorable occasions.
          </>
        ),
        buttonText: "EXPLORE DIAMOND PENDANTS",
        onButtonClick: () => alert("Explore Pendants clicked!"),
      },

      middleImageComponent: [
        {
          type: "image",
          src: NumberPendent1,
          alt: "Earrings Middle 1",
        },
        {
          type: "video",
          src: pandentVideoA,
        },
        {
          type: "image",
          src: NumberPendent2,
          alt: "Earrings Middle 2",
        },

        {
          type: "image",
          src: NumberPendent3,
          alt: "Earrings Middle 1",
        },
        {
          type: "image",
          src: NumberPendent4,
          alt: "Earrings Middle 2",
        },
        {
          type: "video",
          src: pandentVideoB,
          alt: "Earrings Middle 1",
        },
      ],
      smallImgCarousel: [
        {
          src: NumberPendent1,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE PENDANT",
          title: "925 Moissanite Number Pendant 1",
        },
        {
          src: NumberPendent2,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE PENDANT",
          title: "925 Moissanite Number Pendant 1",
        },
        {
          src: NumberPendent3,
          alt: "Moissanite Ring 3",
          content: "PREMIUM | MOISSANITE PENDANT",
          title: "925 Moissanite Number Pendant 1",
        },
        {
          src: NumberPendent4,
          alt: "Moissanite Ring 4",
          content: "LIMITED EDITION | MOISSANITE PENDANT",
          title: "925 Moissanite Number Pendant 1",
        },
        {
          src: heartPendent1,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE PENDANT",
          title: "10ky Initial Cz Heart Pendant A",
        },
        {
          src: heartPendent2,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE PENDANT",
          title: "10ky Initial Cz Heart Pendant A",
        },
        {
          src: heartPendent3,
          alt: "Moissanite Ring 3",
          content: "PREMIUM | MOISSANITE PENDANT",
          title: "10ky Initial Cz Heart Pendant A",
        },
        {
          src: heartPendent4,
          alt: "Moissanite Ring 4",
          content: "LIMITED EDITION | MOISSANITE PENDANT",
          title: "10ky Initial Cz Heart Pendant A",
        },
        {
          src: GlobePendent1,
          alt: "Moissanite Ring 1",
          content: "BEST SELLER | MOISSANITE PENDANT",
          title: "Globe crown Moissanite Pendant",
        },
        {
          src: GlobePendent2,
          alt: "Moissanite Ring 2",
          content: "NEW ARRIVAL | MOISSANITE PENDANT",
          title: "Globe crown Moissanite Pendant",
        },
        {
          src: GlobePendent3,
          alt: "Moissanite Ring 3",
          content: "PREMIUM | MOISSANITE PENDANT",
          title: "Globe crown Moissanite Pendant",
        },
        {
          src: GlobePendent4,
          alt: "Moissanite Ring 4",
          content: "LIMITED EDITION | MOISSANITE PENDANT",
          title: "Globe crown Moissanite Pendant",
        },
      ],

      recentImg: [
        {
          src: heartPendent1,
          alt: "10ky Initial Cz Heart Pendant 1",
          content: "ELEGANT DESIGN | BEST SELLER",
          title: "10ky Initial Cz Heart Pendant 1",
        },
        {
          src: heartPendent2,
          alt: "10ky Initial Cz Heart Pendant 2",
          content: "NEW ARRIVAL | SIGNATURE STYLE",
          title: "10ky Initial Cz Heart Pendant 2",
        },
      ],

      discoverImg: [
        {
          src: Moissanite_A,
          type: "image",
        },
        {
          src: Moissanite_B,
          type: "image",
        },
        {
          src: Moissanite_C,
          type: "image",
        },
        {
          src: Moissanite_D,
          type: "image",
        },
      ],
    },
  },
  {
    id: "5",
    name: "Watches",
    category: "Moissanite Diamond Watches",
    media: {
      carousel: [
        {
          type: "image",
          src: DiamondWatch,
          alt: "Earrings Carousel 1",
        },
        {
          type: "image",
          src: DiamondWatchSlider2,
          alt: "Earrings Carousel 2",
        },
      ],
      imagesComponent: [
        {
          type: "image",
          src: DiamondWatch1,
          alt: "Diamond Watch 1",
          name: "Diamond Watch 1",
        },
        {
          type: "image",
          src: DiamondWatch2,
          alt: "Diamond Watch 2",
          name: "Diamond Watch 2",
        },
        {
          type: "image",
          src: DiamondWatch3,
          alt: "Diamond Watch 3",
          name: "Diamond Watch 3",
        },
        {
          type: "image",
          src: DiamondWatch4,
          alt: "Diamond Watch 4",
          name: "Diamond Watch 4",
        },
      ],
      videoComponent: [{ type: "video", src: video1 }],
      content: {
        title: (
          <>
            Timeless Elegance,
            <br className="hidden md:block" /> Diamond Watches
          </>
        ),
        description: (
          <>
            Discover refined craftsmanship with our latest
            <br className="hidden md:block" />
            collection of diamond watches. Each piece blends
            <br className="hidden md:block" />
            precision with elegance — perfect for layering,
            <br className="hidden md:block" />
            gifting, or collecting.
          </>
        ),
        buttonText: "EXPLORE DIAMOND WATCHES",
        onButtonClick: () => alert("Explore Watches clicked!"),
      },
      middleImageComponent: [
        {
          type: "image",
          src: DiamondWatch1,
          alt: "Earrings Middle 1",
        },
        {
          type: "video",
          src: video1,
        },
        {
          type: "image",
          src: DiamondWatch2,
          alt: "Earrings Middle 2",
        },
        {
          type: "image",
          src: DiamondWatch3,
          alt: "Earrings Middle 1",
        },
        {
          type: "image",
          src: DiamondWatch4,
          alt: "Earrings Middle 2",
        },
        {
          type: "video",
          src: video2,
          alt: "Earrings Middle 1",
        },
      ],
      smallImgCarousel: [
        {
          src: DiamondWatch1,
          alt: "Diamond Watch 1",
          content: "BEST SELLER | DIAMOND WATCH",
          title: "Classic Silver Diamond Watch",
        },
        {
          src: DiamondWatch2,
          alt: "Diamond Watch 2",
          content: "NEW ARRIVAL | DIAMOND WATCH",
          title: "Rose Gold Diamond Watch",
        },
        {
          src: DiamondWatch3,
          alt: "Diamond Watch 3",
          content: "PREMIUM | DIAMOND WATCH",
          title: "Midnight Black Diamond Watch",
        },
        {
          src: DiamondWatch3,
          alt: "Diamond Watch 4",
          content: "LIMITED EDITION | DIAMOND WATCH",
          title: "Blue Sapphire Diamond Watch",
        },
      ],
      recentImg: [
        {
          src: DiamondWatch1,
          alt: "Diamond Watch 1",
          content: "LUXURY TIMEPIECE | BEST SELLER",
          title: "Eternal Diamond Classic Watch",
        },
        {
          src: DiamondWatch2,
          alt: "Diamond Watch 2",
          content: "NEW ARRIVAL | SIGNATURE STYLE",
          title: "Lunar Radiance Diamond Dial",
        },
      ],
      discoverImg: [
        {
          src: DiamondWatch1,
          type: "image",
        },
        {
          src: DiamondWatch2,
          type: "image",
        },
        {
          src: DiamondWatch3,
          type: "image",
        },
        {
          src: DiamondWatch4,
          type: "image",
        },
      ],
    },
  },
];

export const sections = (category: string) => [
  {
    title: "Shop",
    links: [
      // "New Arrivals",
      // "Luxury Watches",
      // "Men’s Watches",
      // "Women’s Watches",
      // "Smart Watches",
      // "Limited Editions",
      "Custom Designs",
      `Gift a ${category}`,
      "Gift Cards",
    ],
  },
  {
    title: "Customer Service",
    links: [
      // "FAQs",
      // "Order Tracking",
      // "Shipping Info",
      "Returns & Exchanges",
      // "Size Guide",
      // "Watch Care Tips",
      "Warranty & Repairs",
      "Contact Support",
    ],
  },
  {
    title: "Services",
    links: [
      "EMI Options",
      //  "Insurance Plans",
      "Gift Wrapping",
    ],
  },
  // {
  //   title: "Manage",
  //   links: [
  //     "My Account",
  //     "My Orders",
  //     "Saved Items",
  //     "Wishlist",
  //     "Track Order",
  //   ],
  // },
  {
    title: "About Us",
    links: [
      "Our Story",
      "Craftsmanship",
      "Store Locator",
      // "Authorized Dealers",
      // "Careers",
      "Privacy Policy",
      "Terms & Conditions",
    ],
  },
];
